import { APIResponse, StoreDetailResponse, StoreListRequestParams } from '@/types';
import {
    StoreListResponse,
    StoreOverviewResponse,
    CreateStoreRequest,
    CreateStoreResponse,
    UpdateStoreRequest,
    UpdateStoreResponse,
    DeleteStoreRequest,
    DeleteStoreResponse,
} from '@/types/pages/admin/stores';

import httpService from '@/api/httpService';

export function fetchStoreListAPI(
    params: StoreListRequestParams,
    options?: { signal?: AbortSignal },
): APIResponse<StoreListResponse> {
    return httpService.get('/store', { params, signal: options?.signal });
}

export function fetchStoreOverviewAPI(
    storeId: number,
    options?: { signal?: AbortSignal },
): APIResponse<StoreOverviewResponse> {
    return httpService.get(`/store/${storeId}/overview`, { signal: options?.signal });
}

export function fetchStoreDetailAPI(
    storeId: number,
    options?: { signal?: AbortSignal },
): APIResponse<StoreDetailResponse> {
    return httpService.get(`/store/${storeId}`, { signal: options?.signal });
}

export function createStoreAPI(data: CreateStoreRequest): APIResponse<CreateStoreResponse> {
    return httpService.post('/store', data);
}

export function updateStoreAPI(storeId: string, data: UpdateStoreRequest): APIResponse<UpdateStoreResponse> {
    return httpService.put(`/store/${storeId}`, data);
}

export function deleteStoreAPI(storeId: number): APIResponse<DeleteStoreResponse> {
    return httpService.delete(`/store/${storeId}`);
}

export function deleteStoreConfirmAPI(storeId: number, data: DeleteStoreRequest): APIResponse<object> {
    return httpService.delete(`/store/${storeId}`, { data });
}
